export const PROTOCOL = "wc";
export const WC_VERSION = 2;
export const CONTEXT = "ethereum_provider";
export const STORAGE_KEY = `${PROTOCOL}@${WC_VERSION}:${CONTEXT}:`;
export const RPC_URL = "https://rpc.walletconnect.org/v1/";
